/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]     .gridHeaderRowCellHeightFix .ag-header-container{width:100%!important}.fill-vertical-lines[_ngcontent-%COMP%]{background-color:orange!important}.verticalSeparator[_ngcontent-%COMP%]{font-size:17px!important;vertical-align:top!important;color:#fc0!important}.delegatedUser[_ngcontent-%COMP%]{margin-top:20px}.fa-user-friends[_ngcontent-%COMP%], .fa-user-slash[_ngcontent-%COMP%]{color:#69a0d5!important}"];
export { styles as styles };
